import { Form, useLoaderData } from "react-router-dom"
import StatCard, { SmallStatCard } from "../components/StatCard";
import StatGraph, { DataMaster } from "../components/StatGraph";
import { Select } from "../components/Select";
import { useEffect, useState } from "react";
import { formatCurrency, getUserId } from "../services/helpers";
import { TextField } from "../components/TextField";
import { getDashboardStats } from "../services/api";
import mixpanel from "../services/mixpanel";


export function Dashboard(){
	//Display toggles
	const [momInterval,setMomInterval] = useState("Monthly");

	const loaderData = useLoaderData();
	const stats = loaderData.stats.stats;
	const highest_earners = stats.highest_earners;
	const [ dataMaster, setDataMaster] = useState( new DataMaster(stats.sales_data, stats.subscription_data));
	const [_showDateFilterPop,_setShowDateFilterPopup] = useState(false);
	const currentYear = new Date().getFullYear();
	const [_filterStartDate, _setFilterStartDate] = useState(new Date(currentYear, 0, 1));
	const [_filterEndDate, _setFilterEndDate] = useState(new Date(currentYear, 11, 31));
	const [dash,setDash] = useState(loaderData.stats.stats.stats);
	const [isLoading, setIsLoading] = useState(false);


	function updateDateRange(e){
		e.preventDefault();
		const formData = new FormData(e.target);
		const startDate = formData.get("start_date");
		const endDate = formData.get("end_date");
		if (startDate) _setFilterStartDate(new Date(startDate));
		if (endDate) _setFilterEndDate(new Date(endDate));
		_setShowDateFilterPopup(false);
	}

	useEffect(()=>{
		mixpanel.identify(getUserId());

	},[])

	useEffect(()=>{
		setIsLoading(true);
		getDashboardStats(_filterStartDate,_filterEndDate).then(result=>{
			console.log(result);
			setDash(result.stats.stats);
			setDataMaster(new DataMaster(result.stats.sales_data,result.stats.subscription_data));
			setIsLoading(false);
		});


	}, [_filterStartDate,_filterEndDate]);



	return (

		<main id="Dashboard">
			<div style={{display: "flex", flexDirection: "row", marginRight: "16px"}}>
				<h1 style={{display: 'inline',alignItems: "center"}}>Dashboard</h1>
				{isLoading && <span className="loader" style={{marginLeft: 16}} />}

				<p style={{marginLeft: "auto", "fontSize" : "small"}}>
					{`${new Date(_filterStartDate)?.toDateString()} to ${new Date(_filterEndDate)?.toDateString()}`}
				</p>

				<div className="popup-container" style={{"marginLeft": "0.5em", "marginTop": "1em"}} >
					<button className="link" onClick={()=>_setShowDateFilterPopup(prev=>!prev)}>Filter by Date</button>
				{_showDateFilterPop && <span className="popup">

					<div className="row space-between" style={{marginBottom: "12px"}}>
						<button className="link" onClick={()=>{
							_setFilterStartDate(new Date(currentYear, 0, 1));
							_setFilterEndDate(new Date(currentYear, 11, 31));
							_setShowDateFilterPopup(false);
						}}>All Time</button>
						<button className="link" onClick={()=>_setShowDateFilterPopup(false)}>This Year</button>
					</div>
					<Form onSubmit={updateDateRange}>

						<TextField
							label="Start Date"
							name="start_date"
							defaultValue={new Date(_filterStartDate)?.toISOString().slice(0, 10) ?? ""}
							type="date"
							// onChange={(e)=> _setFilterStartDate(e.target.value)}
						/>
						<TextField
							label="End Date"
							name="end_date"
							defaultValue={new Date(_filterEndDate)?.toISOString().slice(0, 10) ?? ""}
							type="date"
							// onChange={(e)=> _setFilterEndDate(e.target.value)}
						/>
						<div className="row space-between">
							<button className="link red-text" onClick={()=>{
								_setFilterStartDate(new Date(currentYear, 0, 1));
								_setFilterEndDate(new Date(currentYear, 11, 31));
								_setShowDateFilterPopup(false);
							}}>Reset</button>
							<button className="link" type="submit">Apply</button>
						</div>
					</Form>
				</span>}
				</div>

			</div>


		<div id="stat-card-row" className="row">
			<StatCard
			label="Total Revenue (GHS)"
			value={formatCurrency(dash.total_revenue)}
			// target={159400}
			/>
			<StatCard
			label="Number of Customers"
			value={dash.total_customers}
			/>
			<StatCard
			label="Jobs Completed"
			value={dash.jobs_completed}
			/>
			<StatCard
			label="Active members"
			value= {dash.active_members}
			secondaryValue={dash.all_members}
			/>
		</div>

		<div className="column">

			<div id="sub-main" className="col">
				<div>
					<div className="row" style={{justifyContent:"space-between"}}>

						<h3 className="section-header" style={{display: "inline-block"}}>Month on Month Revenue</h3>

						<div id="filterDiv" className="filter-select">
							{/* <Select
								label={"Breakdown"}
								defaultValue={"Total"}
								options={["Total","Compare"]}
								onChange={(e) => setMomBreakdown(e.target.value)}
							/> */}
							<Select
							label={"Interval"}
								// defaultValue={"Daily"}
								defaultValue="Monthly"
								options={["Daily","Monthly"]}
								onChange={(e) => setMomInterval(e.target.value)}
							/>
						</div>
					</div>
					<div className="row">
						{/* <div>
							<table>
				<thead>
					<tr>
						<th>Item</th>
						<th>Day</th>
						<th>Month</th>
						<th>Year</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Number of Services</td>
						<td>50</td>
						<td>50</td>
						<td>50</td>
					</tr>
					<tr>
						<td>Revenue</td>
						<td>50</td>
						<td>50</td>
						<td>50</td>
					</tr>
					<tr>
						<td>Expenses</td>
						<td>50</td>
						<td>50</td>
						<td>50</td>
					</tr>
				</tbody>
			</table>
						</div> */}
						<div style={{width: "60%"}}>
<StatGraph
						series ={dataMaster.get_graph_data(momInterval)}
						interval={momInterval}
					/>
						</div>
					</div>

				</div>
			</div>


			<div id="category-stats">
				<h3 className="section-header">Revenue Streams</h3>

				<div className="container row">
					<h3 className="label">GHS</h3>
					{Object.entries(dataMaster.get_revenue_streams()).map((entry,index)=> {
						return <SmallStatCard
						key={index}
							label={entry[0]}
							value={formatCurrency(entry[1])}
						/>;
						})}
				</div>
			</div>
		</div>

		<div className="row">
			<div id="highest-earners-table">
			<h4>Customers by Revenue</h4>
			<table>
				<thead>
					<tr>
						<th>Customer Name</th>
						<th>Revenue</th>
					</tr>
				</thead>
				<tbody>
					{
						highest_earners.map(entry=>{
							return <tr key={entry.uuid}>
								<td>{entry.first_name} {entry.last_name}</td>
								<td>GHS {formatCurrency(entry.total_spend)}</td>
							</tr>}
						)
					}
				</tbody>
			</table>
		</div>

		</div>





		</main>
	)
}

